<template>
  <model-table
    :collection="connectorCollection"
    :show-add="forStation"
    :submodel="forStation"
    :edit-mode="forStation"
    :edit-mode-add-using-form="true"
    :columns="columns"
  >
    <template
      v-if="!forStation"
      #header-controls
    >
      <q-btn-group>
        <q-btn
          v-for="option in filterOptions"
          :key="option.value"
          :label="option.label"
          :color="option.value === currentFilter ? 'primary' : 'grey'"
          @click="() => currentFilter = option.value"
        />
      </q-btn-group>
    </template>
    <template
      #custom-component="props"
    >
      <div
        v-for="input in props.value"
        :key="input.label || input.value"
        class="row"
      >
        <q-checkbox
          v-if="input.value === true || input.value === false"
          :label="input.label"
          :model-value="input.value"
          disable
        />
        <q-input
          v-else
          dense
          :label="input.label"
          :model-value="input.value"
          readonly
        />
      </div>
    </template>
    <payment-connector-configuration-form
      :can-enable="canEnable"
      :register-station="registerStation"
      :existing-connectors="existingConnectors"
    />
  </model-table>
</template>

<script>

import RegisterStation from 'src/models/register/RegisterStation'
import ModelTable from 'src/modules/admin/components/ModelTable'
import PaymentConnectorConfigurationForm from 'src/modules/admin/payment-connector/PaymentConnectorConfigurationForm'

export default {
  name: 'PaymentConnectorConfigurationTable',
  components: {
    ModelTable,
    PaymentConnectorConfigurationForm
  },
  props: {
    registerStation: {
      type: RegisterStation,
      required: false,
      default: null
    },
    developerMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentFilter: this.developerMode ? 'global' : 'site'
    }
  },
  context: ['currentUser'],
  computed: {
    columns () {
      const columns = [
        { field: 'id' },
        { name: 'name', field: (row) => _.startCase(row.name) },
        { field: 'configurationSummary', component: 'custom-component' }
      ]

      // If viewing by station, we want to be able to pick the connector in the table, as this is a sub component of the register station form
      if (this.forStation) {
        columns.push({
          field: 'enabled',
          editor: { component: 'checkbox-action', trueValue: true, falseValue: false, label: '', inputCallback: this.toggleEnable }
        })
      } else {
        columns.push({ field: 'enabled', component: 'checkbox' })
      }

      // If in developer mode we can see all sites and the global configuration for the region
      if (this.developerMode) {
        columns.push({
          name: 'Site',
          field: row => (row.site && row.site.name) || 'Global',
          component: 'chip'
        })
      }

      // Logging for a payment connector can be enabled only by a super user
      // This is for troubleshooting purposes and not generally required unless a bug is suspected
      if (this.currentUser.superUser) {
        columns.push({ field: 'loggingEnabled', component: 'checkbox' })
      }

      // If viewing by station we want to show the station
      if (this.currentFilter === 'stations') {
        columns.push({ field: 'registerStation', component: 'model' })
      }

      return columns
    },
    filterOptions () {
      if (this.developerMode) {
        // Global: The configuration for the region
        return [{ label: 'Global', value: 'global' },
          { label: 'Site', value: 'site' },
          { label: 'All Sites', value: 'all_sites' }
        ]
      } else if (!this.forStation) {
        return [{ label: 'Site', value: 'site' }, { label: 'Stations', value: 'stations' }]
      } else {
        return [{ label: 'Station', value: 'station' }]
      }
    },
    connectorCollection () {
      return this.forStation ? this.registerStation.paymentConnectorConfigurations : this.paymentConnectorConfigurations
    },
    forStation () {
      return !!this.registerStation
    },
    canEnable () {
      if (this.forStation) {
        return !_.some(this.registerStation.paymentConnectorConfigurations.data, 'enabled')
      } else {
        return true
      }
    },
    existingConnectors () {
      return _.map(this.connectorCollection.data, (connector) => connector.name)
    }
  },
  methods: {
    toggleEnable (value, row) {
      _.each(this.registerStation.paymentConnectorConfigurations.data, config => {
        config.enabled = false
      })
      row.enabled = value
    }
  },
  models: {
    paymentConnectorConfigurations: {
      loggingEnabled: true,
      site: {
        fields: ['name', 'id']
      },
      registerStation: {
        fields: ['name', 'id']
      },
      configurationIgnoreKeys: true,
      variables () {
        return {
          registerStationId: this.registerStation?.id,
          developerMode: this.developerMode,
          filter: this.currentFilter
        }
      }
    }
  }
}
</script>
